// @ts-ignore
import { Fancybox } from "@fancyapps/ui"
import { Carousel } from "@fancyapps/ui"
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "@fancyapps/ui/dist/carousel/carousel.css";
// @ts-ignore
import { en } from '@fancyapps/ui/dist/fancybox/l10n/en.esm.js';
// @ts-ignore
import { de } from '@fancyapps/ui/dist/fancybox/l10n/de.esm.js';

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

const breadcrumb = document.getElementById('breadcrumb-nav')
function updateBreadcrumb(title: string) {
    if (breadcrumb) {
        const breadcrumbNav = breadcrumb.querySelectorAll<HTMLElement>('ul')
        const fancyboxTitle = breadcrumbNav[0]?.querySelector('.fb-title')
        if (!title && fancyboxTitle) {
            breadcrumbNav[0].removeChild(fancyboxTitle);
        } else if (fancyboxTitle) {
            fancyboxTitle.innerHTML = title
        } else {
            const li = document.createElement('li')
            li.classList.add('fb-title')
            li.textContent = title
            breadcrumbNav[0]?.appendChild(li)
        }
    }
}

function slugify(str: string) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    return str;
}

/** Fancybox */
const fancyboxLanguages = {
    en: en,
    de: de,
    'de-DE': de,
    'en-us': en
}
if (fancyboxLanguages[document.documentElement.lang]) {
    Fancybox.defaults.l10n = fancyboxLanguages[document.documentElement.lang]
}
Fancybox.bind("[data-fancybox]", {
    on: {
        init: (fancybox) => {
            document.documentElement.classList.add('fancybox-open')
        },
        "Carousel.ready Carousel.change": (fancybox) => {
            const title = fancybox.getSlide().contentEl.getAttribute('data-fancybox-title')
            updateBreadcrumb(title)
            // Add virtual_page_view for Google
            const page_title = document.title
            const page_location = window.location.href.split('#')[0]
            const page_path = slugify(title)
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'virtual_page_view',
                page_title: page_title,
                page_location: page_location,
                page_path: '/' + page_path
            });
        },
        close: (fancybox) => {
            updateBreadcrumb('')
            document.documentElement.classList.remove('fancybox-open')
        }
    },
    tpl: {
        closeButton:
            '<button data-fancybox-close class="fancybox-close-btn" title="{{CLOSE}}"><span class="text">{{CLOSE}}</span> <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><path d="M21.98,20,34,7.98,32.02,6,20,18.02,7.98,6,6,7.98,18.02,20,6,32.02,7.98,34,20,21.98,32.02,34,34,32.02Z" transform="translate(0 0)" fill="#fff"/></svg></span></button>',
    },
    Carousel: {
        Dots: false,
        Navigation: false,
        transition: 'fade',
        infinite: true,
        Panzoom: {
            touch: false
        }
    },
    animated: false,
    autoFocus: false,
    placeFocusBack: false,
    dragToClose: false,
    closeExisting: true
})

const prevButtons = document.querySelectorAll('.fancybox-controls .slide-nav li.prev a')
if (prevButtons) {
    for (const prevButton of prevButtons) {
        prevButton.addEventListener('click', event => {
            event.preventDefault()
            //console.log('Click prev')
            const fancybox = Fancybox.getInstance()
            fancybox?.prev()
        })
    }
}
const nextButtons = document.querySelectorAll('.fancybox-controls .slide-nav li.next a')
if (nextButtons) {
    for (const nextButton of nextButtons) {
        nextButton.addEventListener('click', event => {
            event.preventDefault()
            //console.log('Click next')
            const fancybox = Fancybox.getInstance()
            fancybox?.next()
        })
    }
}
const fancyboxLinks = document.querySelectorAll('.fancybox-content-box .text-wrapper a')
if (fancyboxLinks) {
    for (const fancyboxLink of fancyboxLinks) {
        fancyboxLink.addEventListener('click', event => {
            if (fancyboxLink?.pathname && fancyboxLink?.pathname == window.location.pathname) {
                event.preventDefault()
                //console.log('window.location.href: ' + window.location.href)
                //console.log('fancyboxLink.href: ' + fancyboxLink.href)

                const fancybox = Fancybox.getInstance()
                fancybox?.close()
                window.setTimeout(function () {
                    window.location.href = fancyboxLink.href
                }, 800);
            }
        })
    }
}